module.exports = __webpack_public_path__ + "static/media/basemap_esri_world.6d43af0e.png";